enum FormMode {
  OnChange = 'onChange',
  OnBlur = 'onBlur',
  OnSubmit = 'onSubmit',
  OnTouched = 'onTouched',
  All = 'all',
}

export default FormMode;
